import { createAction } from '@reduxjs/toolkit'

export const resetAllReduxStates = createAction('resetAllReduxStates')
